import { forwardRef as e } from "react";
import { useThemeUI as p } from "theme-ui";
import { Button as c } from "../Button.js";
import "@material-bank/ds-utils";
import "@material-bank/mb-icons";
import { useVariants as u } from "../../../lib/css/css-hooks.js";
import "../../../lib/css/match-media-context.js";
import "@theme-ui/css";
import { jsx as a } from "theme-ui/jsx-runtime";
const f = e((t, o) => {
  const {
    icon: r,
    size: n = "lg",
    ...i
  } = t, {
    theme: m
  } = p(), s = u({
    size: m.iconButtonSizes
  });
  return /* @__PURE__ */ a(c, {
    ref: o,
    ...i,
    startIcon: r,
    sx: {
      ...s({
        size: n
      }),
      ...t.sx
    }
  });
});
f.displayName = "IconButton";
export {
  f as IconButton
};
